import { differenceInDays, formatDistanceToNowStrict } from 'date-fns';
import DateFnLanguage from '../constants/DateFnLanguage';

/**
 * @param {Date} lastLogin
 * @param {string} lastLoginFormatted
 * @param {string} language language key
 * @returns {string}
 */
export default function getLastLoginContent(lastLogin, lastLoginFormatted, language) {
    if (!lastLogin || !language) {
        return '';
    }
    const diffDays = differenceInDays(Date.now(), lastLogin);
    if (diffDays <= 7) {
        return formatDistanceToNowStrict(lastLogin, {
            addSuffix: true,
            locale: DateFnLanguage[language],
        });
    }
    return lastLoginFormatted;
}
